export default __webpack_public_path__ + "static/media/flisekompaniet-footer.36943fad.JPG";